import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { useTransactionsFilters } from '../../../hooks/useTransactionsFilters';
import { mapTransactionsFiltersFormToQueryVariables } from '../../utils';
import { TransactionsSearchDocument } from './transactionsSearch.gql';

const useTransactionsSearch = ({
  bankAccountId,
  searchTerm,
}: {
  bankAccountId?: string;
  searchTerm: string;
}) => {
  const { filters } = useTransactionsFilters();
  const { companyProfileId } = useCompanyContext();

  const hook = useQuery(TransactionsSearchDocument, {
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !bankAccountId && !companyProfileId,
    variables: mapTransactionsFiltersFormToQueryVariables({
      bankAccountId,
      companyProfileId: companyProfileId ?? '',
      filters: { ...filters, q: searchTerm.replace(',', '.') },
    }),
  });

  const transactionsTotalAmount =
    hook.data?.viewer.company.transactionsSearch.edges.reduce(
      (acc, curr) => curr.node.value + acc,
      0,
    ) ?? 0;

  return {
    ...hook,
    transactionsTotalAmount,
  };
};

export default useTransactionsSearch;
